var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "push_pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2178",
    "data-name": "\\uADF8\\uB8F9 2178"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2423",
    "data-name": "\\uC0AC\\uAC01\\uD615 2423",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2424",
    "data-name": "\\uC0AC\\uAC01\\uD615 2424",
    width: 18,
    height: 18,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2179",
    "data-name": "\\uADF8\\uB8F9 2179",
    transform: "translate(4.609 1.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1050",
    "data-name": "\\uD328\\uC2A4 1050",
    d: "M14.771,10.016a.759.759,0,0,0-.558-.723,2.194,2.194,0,0,1-1.535-2.131V3.475h.7a.721.721,0,0,0,.7-.737.721.721,0,0,0-.7-.737H6.4a.721.721,0,0,0-.7.737.721.721,0,0,0,.7.737h.7V7.162A2.194,2.194,0,0,1,5.558,9.293.759.759,0,0,0,5,10.016v.1a.721.721,0,0,0,.7.737H9.174l.014,5.162a.7.7,0,1,0,1.4,0l-.014-5.162h3.5a.721.721,0,0,0,.7-.737Z",
    transform: "translate(-5 -2)",
    fill: "#0072ce",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.2a147d246ed3084bc066035128403d2b.svg";
export { ForwardRef as ReactComponent };